import { lazy, Suspense } from 'react';
import { useIsDesktop } from '../lib/media';

// Loaded on demand so the Portfolio page doesn't grow the main (trading) bundle.
const PortfolioView = lazy(() => import('./portfolio/PortfolioView'));
const MobilePortfolio = lazy(() => import('./portfolio/MobilePortfolio').then((m) => ({ default: m.MobilePortfolio })));

export function PortfolioPage() {
  const desktop = useIsDesktop();
  return <Suspense fallback={null}>{desktop ? <PortfolioView /> : <MobilePortfolio />}</Suspense>;
}
